import { useEffect, useRef } from 'react';
import { consumer } from '../../../helpers/consumer.js';

export default function useDatasourceWidgetChannel(datasourceId, projectId, refresh) {
  const subscriptionRef = useRef(null);

  useEffect(() => {
    if (!datasourceId) return;

    subscriptionRef.current = consumer.subscriptions.create(
      { channel: 'DatasourceWidgetChannel', datasource_id: datasourceId, project_id: projectId },
      {
        received: (data) => {
          if (data.refreshed) {
            refresh();
            window.ToastNotification({ message: `${I18n.t('refreshed')}!`, horizontal: 'center', vertical: 'top', autoHideDuration: 5 });
          }
        },
      },
    );

    return () => {
      subscriptionRef.current?.unsubscribe();
      subscriptionRef.current = null;
    };
  }, [datasourceId]);

  return subscriptionRef;
}